var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import MenuAll from "./menuAll";
import Menuh from "./menuh";
import { useGetAllMenuQuery } from "@/store/api";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useMemo } from "react";
import { slotDirection } from "@/utils/funcs";
import { SlotDirection } from "@/utils/types/layout";
export default function Menu(props) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var menuResponse = useGetAllMenuQuery(null).data;
    var mainMenu = useMemo(function () {
        var _a;
        var mainMenu = {};
        var main = ((_a = menuResponse === null || menuResponse === void 0 ? void 0 : menuResponse.data) === null || _a === void 0 ? void 0 : _a.main) || [];
        var list = main || {};
        var links = list.links;
        for (var key in list.tabs) {
            var modules = list.tabs[key].modules;
            var moduleLinks = [];
            for (var moduleKey in modules) {
                moduleLinks[moduleKey] = {
                    modules: links[moduleKey],
                };
            }
            mainMenu[key] = { modules: moduleLinks };
        }
        return mainMenu;
    }, [menuResponse]);
    var direction = (props === null || props === void 0 ? void 0 : props.widget.slot)
        ? slotDirection(props === null || props === void 0 ? void 0 : props.widget.slot)
        : SlotDirection.VERTICAL;
    var MenuComponent = direction === SlotDirection.HORIZONTAL ? Menuh : MenuAll;
    return _jsx(MenuComponent, __assign({}, props, { menuItem: mainMenu }));
}
widgetsDictionary.register("etcrm/widgets/default/menu", {
    name: "Menu",
    display: Menu,
    selectable: false,
});
